import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';

const NotFoundPage: React.FC = () => {
  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Col md={8} lg={6} className="text-center">
          <div className="mb-4">
            <h1 className="display-1 text-primary">404</h1>
            <h2 className="mb-3">Page Not Found</h2>
            <p className="lead text-muted mb-4">
              The page you're looking for doesn't exist or has been moved.
            </p>
          </div>
          
          <div className="d-flex gap-3 justify-content-center flex-wrap">
            <Link to="/" className="btn btn-primary btn-lg">
              Go Home
            </Link>
            <Link to="/about" className="btn btn-outline-secondary btn-lg">
              About Us
            </Link>
            <Link to="/help" className="btn btn-outline-secondary btn-lg">
              Get Help
            </Link>
          </div>
          
          <hr className="my-5" />
          
          <div className="text-muted">
            <p className="mb-0">
              If you believe this is an error, please{' '}
              <Link to="/help" className="text-decoration-none">
                contact support
              </Link>
              .
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default NotFoundPage;
